import { RepairOrderFragment } from "@/Common/api/fragments/technicians/repairOrder";

// Tag for graphql format
const gql = String.raw;

const TechnicianPerformanceFragment = gql`
	fragment TechnicianPerformance on TechnicianPerformance {
		repairOrders {
			...RepairOrder
		}
		totals {
			actualTime
			bookedTime
			bonusTime
			rate
			extended
			extendedBonus
		}
	}
	${RepairOrderFragment}
`;

export { TechnicianPerformanceFragment };
